import { ToastContextType, useToasts } from '@/contexts/toast-context';
import { useCallback, useRef } from 'react';

export const useUniqueErrorToast = (): ToastContextType['showErrorToast'] => {
  const { showErrorToast } = useToasts();
  const toastShown = useRef(false);

  return (message, onClose) => {
    if (toastShown.current) {
      return;
    }

    toastShown.current = true;
    return showErrorToast(message, () => {
      toastShown.current = false;
      onClose?.();
    });
  };
};

export const useUniqueToast = (): ToastContextType['showToast'] => {
  const { showToast } = useToasts();
  const toastShown = useRef(false);

  return useCallback(
    (options) => {
      if (toastShown.current) {
        return;
      }

      toastShown.current = true;
      return showToast({
        ...options,
        onClose: () => {
          toastShown.current = false;
          options.onClose?.();
        },
      });
    },
    [showToast],
  );
};
